import { PACKAGES } from "@/data/content";
import { Reveal, LineReveal, Stagger, Item } from "./motion/Reveal";
import { scrollToId } from "@/lib/scroll";

export const Packages = () => (
  <section id="packages" data-testid="packages-section" className="section-y bg-cream">
    <div className="container-x">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-end mb-16 lg:mb-20">
        <div className="lg:col-span-7">
          <Reveal><p className="eyebrow mb-6">Packages</p></Reveal>
          <LineReveal inView as="h2" lines={["Four ways to begin.", <><span className="italic text-sage">Endless</span> ways to tailor.</>]} className="h2" />
        </div>
        <Reveal delay={0.2} className="lg:col-span-5 body-lg">
          Each package is a starting point, shaped further around your business. Share your requirements and we will recommend the right direction with a personalised quote.
        </Reveal>
      </div>

      <Stagger className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-5 lg:gap-6">
        {PACKAGES.map((p, i) => (
          <Item key={p.id} data-testid={`package-card-${p.id}`} className={`card-lift group relative flex flex-col p-8 lg:p-9 min-h-[440px] border ${p.exclusive ? "bg-charcoal text-ivory border-charcoal xl:-mt-6 xl:mb-[-1.5rem]" : "bg-ivory border-taupe-line hover:border-sage/50"} ${i === 1 ? "xl:mt-10" : ""} ${i === 2 ? "xl:mt-5" : ""}`}>
            {p.exclusive && <span className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-gold/70 to-transparent" />}
            <div className="flex items-start justify-between">
              <span className={`font-serif text-5xl font-light leading-none ${p.exclusive ? "text-gold/80" : "text-taupe/70"}`}>{p.numeral}</span>
              {p.exclusive && <span className="font-mono text-[9px] uppercase tracking-[0.28em] text-gold/80 border border-gold/30 px-3 py-1.5">Most Exclusive</span>}
            </div>
            <h3 className="font-serif text-4xl font-light mt-14 leading-none">{p.name}</h3>
            <p className={`mt-6 text-sm sm:text-[15px] leading-relaxed font-light ${p.exclusive ? "text-ivory/70" : "text-ink/70"}`}>{p.desc}</p>
            <div className="mt-auto pt-10">
              <button data-testid={`package-cta-quote-${p.id}`} onClick={() => scrollToId("contact")} className={`btn w-full ${p.exclusive ? "btn-light" : "btn-outline"}`}>
                <span>Get a Quote</span>
              </button>
            </div>
          </Item>
        ))}
      </Stagger>
      <Reveal delay={0.3} className="mt-10 text-center text-xs text-taupe font-light">Not sure which package suits you? Tell us about your project and we will guide you.</Reveal>
    </div>
  </section>
);
